import * as Store from '@apply/store';
import { connect } from 'react-redux';
import { QuestionValidateType, ShowIf } from '@apply/ui';
import {
    BudgetFileLand,
    BuildOnLandYourself,
    ContactInformation,
    ExitPlans,
    GeneralContractor,
    GeneralContractorCompany,
    GeneralContractorFile,
    IntendedWork,
    LandSize,
    LegalDescription,
    OnsitePropertyContact,
    PerformingSiteWork,
    PlattedLotsCurrent,
    PlattedLotsPlanned,
    RequiredInspections,
    SurveyFile,
    PropertyAddress,
    ZoningOrEntitlement,
} from '../questions/index';

export interface LandProps {
    onQuestionValidate?: QuestionValidateType;
    submitted: boolean;
    handleFileSelected: (
        fileType: string,
        file: File,
        updater: (guid: string, value: Store.PropertiesStore.Types.Attachment) => unknown
    ) => Promise<void>;
    disableEditFormOptionBudget: boolean;
    property: Store.PropertiesStore.Types.Property;
}

const Land: React.FC<LandProps> = ({
    onQuestionValidate,
    submitted,
    handleFileSelected,
    disableEditFormOptionBudget,
    property,
}) => {
    return (
        <>
            <PropertyAddress
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                required={true}
            />
            <LegalDescription
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
            />
            <LandSize
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
            />

            <PlattedLotsCurrent
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                required={true}
            />
            <PlattedLotsPlanned
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                required={true}
            />
            <IntendedWork
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                required={true}
            />
            <ZoningOrEntitlement
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                required={true}
            />
            <ShowIf showIf={property.nonRental?.requiredZoningOrEntitlement === true}>
                <RequiredInspections
                    onQuestionValidate={onQuestionValidate}
                    submitted={submitted}
                    required={true}
                />
            </ShowIf>

            <GeneralContractor
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                required={true}
            />
            <ShowIf showIf={property.nonRental?.generalContractorWillWork}>
                <GeneralContractorCompany
                    onQuestionValidate={onQuestionValidate}
                    submitted={submitted}
                    required={true}
                />
                <GeneralContractorFile
                    onQuestionValidate={onQuestionValidate}
                    submitted={submitted}
                    handleFileSelected={handleFileSelected}
                    required={true}
                />
            </ShowIf>
            <ShowIf showIf={!property.nonRental?.generalContractorWillWork}>
                <OnsitePropertyContact
                    onQuestionValidate={onQuestionValidate}
                    submitted={submitted}
                    required={true}
                />
            </ShowIf>
            <ShowIf showIf={!property.nonRental?.generalContractorWillWork && property.nonRental?.contactIsPrimary === false}>
                <ContactInformation
                    onQuestionValidate={onQuestionValidate}
                    submitted={submitted}
                />
            </ShowIf>

            <BudgetFileLand
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                handleFileSelected={handleFileSelected}
                disableEditFormOptionBudget={disableEditFormOptionBudget}
                required={true}
            />
            <SurveyFile
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                handleFileSelected={handleFileSelected}
                required={true}
            />
            <BuildOnLandYourself
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                required={true}
            />
            <ShowIf showIf={property.nonRental?.willBuildOnLandYourself === false}>
                <ExitPlans
                    onQuestionValidate={onQuestionValidate}
                    submitted={submitted}
                    required={true}
                />
            </ShowIf>
            <PerformingSiteWork
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                required={true}
            />
        </>
    );
};

export const mapStateToProps = (state: Store.ApplyRootStateType) => {
    return {
        property: state.properties.items.find((itm) => itm.guid === state.properties.currentPropertyId),
    };
};

export default connect(mapStateToProps)(Land);
